import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "../../../context/AppConfigProviderContext.tsx";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const Wheelbase = ({ wheelbase }: SpecProps<"wheelbase">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (!wheelbase) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.wheelbase",
    message: "Wheelbase",
    comment: "Field for 'Wheelbase' for bus and truck in ad specification",
  });

  const value = i18n.t({
    id: "itemPageLayout.common.length.value",
    message: "{length} cm",
    comment: "Length incl. postfix in cm",
    values: {
      length: formatNumber(wheelbase, locale),
    },
  });

  return <FieldValuePair field={field} value={value} />;
};
